import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class OfferService {
  private apiUrl = `${environment.baseURL}api/f/offers`;

  constructor(private http: HttpClient) { }

  // Get all offers
  getAllOffers(): Observable<any> {
    return this.http.get(`${this.apiUrl}/allOffers`);
  }

  // Get single offer by id
  getOffer(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/getOffer/${id}`);
  }

  // Create new offer (expects JSON body with title, description, image, category, pageLink)
  addOffer(offer: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/addOffer`, offer);
  }

  // Update an offer by id
  updateOffer(id: string, offer: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, offer);
  }

  // Delete an offer by id
  deleteOffer(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/delete/${id}`);
  }
}